import { AuthProvider } from "./context/AuthContext";
import { useAuth } from "./hooks/useAuth";
import { useFeedbackWidget } from "./hooks/useFeedbackWidget";
import { AppShell } from "./screens/AppShell";
import { LoginScreen } from "./screens/LoginScreen";

/**
 * Top-level screen gate. `LoginScreen` owns the entire pre-app flow (sign in, check session, offer
 * bootstrap); `AppShell` takes over once the session can do *something* — administer this
 * deployment, use the chat, or both.
 *
 * A non-admin was previously stranded on the login screen with an explanation, because the console
 * was all there was. With chat bundled, that same person has a surface of their own, and the shell
 * decides which tabs they see. This is still the only branch point in client-side navigation.
 */
function Gate(): JSX.Element {
  const { session } = useAuth();
  const admitted = session !== null && (session.is_admin || session.chat_available);
  return admitted ? <AppShell /> : <LoginScreen />;
}

export function App(): JSX.Element {
  // Above the gate, so the bug-capture widget is there on the login screen too — someone who
  // cannot sign in is exactly the person with something to report.
  useFeedbackWidget();
  return (
    <AuthProvider>
      <Gate />
    </AuthProvider>
  );
}
